// src/lib/data-access/global-search.state.ts

import {ICycle, MinimalUserModel, UserGroup} from '@core/api/data-access';

/**
 * Generic לטיפול ב־pagination + loading + error
 */
export type ISearchDataState<T> = {
	items: T[];
	page: number;
	size: number;
	total: number;
	status: 'idle' | 'loading' | 'error';
	error?: unknown;
};

/**
 * ה־State הראשי של ה־Global Search
 */
export type IGlobalSearchDataState = {
	cycles: ISearchDataState<ICycle>;
	users: ISearchDataState<MinimalUserModel>;
	userGroups: ISearchDataState<UserGroup>;

	loadedQueries: string[]; // סט של מחרוזות חיפוש שכבר נטענו
};

/**
 * ערכי ברירת המחדל של ה־State
 */
export const DEFAULT_PAGE_SIZE = 5;
export const initialGlobalSearchDataState: IGlobalSearchDataState = {
	cycles: {items: [], page: 1, size: DEFAULT_PAGE_SIZE, total: 0, status: 'idle'},
	users: {items: [], page: 1, size: DEFAULT_PAGE_SIZE, total: 0, status: 'idle'},
	userGroups: {items: [], page: 1, size: DEFAULT_PAGE_SIZE, total: 0, status: 'idle'},

	loadedQueries: [],
};
